import * as React from 'react'
import { BonusToolbarState } from './hooks/useBonusRewardsToolbar'

type PayrollActionBarContextType = {
  toolbarState: BonusToolbarState
  onToggleBailiffDeduction: () => void
  onToggleEquivalent: () => void
  onToggleAutomaticOvertime: () => void
  onToggleZusPaidFromAverageGross: () => void
  onToggleLeaveAdditionColumns: () => void
  onSetDomesticTripType: (value: 'start' | 'end') => void
  isDirty: boolean
  // True while the grid is still streaming rows for the side-panel selection —
  // actions built from grid state (calculate/delete/print) must wait for it.
  isRowsLoading: boolean
  // Ktos juz przelicza ten okres. Serwer i tak odrzuci drugie zadanie (409), wiec
  // wygaszamy przycisk zamiast pozwalac klikac w cos, co nie ma jak sie udac.
  calculateBusy: boolean
  // Login osoby, ktora to uruchomila - null, gdy to nasze wlasne zadanie.
  calculateBusyBy: string | null
  showOnlySelected: boolean
  onToggleShowOnlySelected: () => void
  showOnlyNettoMismatch: boolean
  onToggleShowOnlyNettoMismatch: () => void
  // Ile zaznaczonych wierszy ma trójkąt w „Wyliczone netto”; filtr zawęża do nich panel boczny.
  nettoMismatchCount: number
  onSubmit: () => void
  // "Przelicz zmodyfikowanych" - liczy wylacznie wiersze z niezapisana edycja.
  onSubmitModified: () => void
  // Ile wierszy ma niezapisana edycje (0 = przycisk ukryty).
  modifiedCount: number
  onClearAll: () => void
  onDelete: () => void
  onPrint: () => void
  printShortcuts?: React.ReactNode
  onRefresh: () => void
  onImport: () => void
  onUnselect: () => void
}

const PayrollActionBarContext =
  React.createContext<PayrollActionBarContextType | null>(null)

type ProviderProps = PayrollActionBarContextType & { children: React.ReactNode }

export const PayrollActionBarProvider: React.FC<ProviderProps> = ({
  children,
  ...value
}) => (
  <PayrollActionBarContext.Provider value={value}>
    {children}
  </PayrollActionBarContext.Provider>
)

export const usePayrollActionBar = (): PayrollActionBarContextType => {
  const ctx = React.useContext(PayrollActionBarContext)
  if (!ctx)
    throw new Error(
      'usePayrollActionBar must be used within PayrollActionBarProvider',
    )
  return ctx
}
